import { cn } from '@shared/utils';

interface SlideAddProps {
  className?: string;
  text: string;
  style?: { width: string | number; height: string | number };
  onClick: () => void;
}

export const SlideAdd = (props: SlideAddProps) => {
  return (
    <div className={cn(props.className, props.text === 'Add card' && 'aspect-[5/3]')} style={props.style} onClick={props.onClick}>
      <div
        className={cn(
          'h-full w-full rounded border-2 border-[#585858] bg-gradient-to-b from-[#282828] to-[#212121] transition-all duration-100 ease-linear',
          'hover:rounded hover:border-0 hover:border-transparent hover:shadow-[12px_12px_24px_0_#0000003b]',
          props.text === 'Add card' && 'rounded-2xl',
        )}
      >
        <div className='flex h-[inherit] flex-col items-center justify-center'>
          <div>
            <svg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'>
              <path d='M28 15h-13v13h-2v-13h-13v-2h13v-13h2v13h13z' fill='#585858' />
            </svg>
          </div>
          <div className='mt-2.5 text-sm text-[#585858] uppercase'>{props.text}</div>
        </div>
      </div>
    </div>
  );
};
